import { ModalTypes } from "../TargetTypeManagement";
import { getDeletePopup } from "../../../view/popup/PopupContainer";
import { removeDeviceTypeList } from "../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../validation/ToastContainer";

export class DeviceTypeManager {

    constructor(setModalProps, setModalType, setShowModal, setPopup, elements) {
        this.setShowProps = setModalProps;
        this.setModalType = setModalType;
        this.setShowModal = setShowModal;
        this.setPopup = setPopup;
        this.elements = elements;
    }

    showAddModal = () => {
        this.setModalType(ModalTypes.CREATE);
        this.setShowModal(true);
    }

    showEditModal = () => {

        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;

        const modalProps = {
            title: "Edit Device Type",
            text: "Select Device Types",
            elements: this.elements,
            onClick: (element) => {
                setModalProps({ selectedDeviceType: element })
                setModalType(ModalTypes.EDIT);
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.SELECT);
        setShowModal(true);

    }

    showRemoveModal = () => {


        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;
        const setPopup = this.setPopup;

        const modalProps = {
            title: "Remove Device Type",
            text: "Select Device Types",
            elements: this.elements,
            onSubmit: (deviceTypes) => {
                setPopup(
                    getDeletePopup('Are you sure you want to remove the selected device types?',
                        'Remove Device Types',
                        () => removeDeviceTypeList(deviceTypes)
                            .then((errors) => {
                                setShowModal(false);
                                if (errors.length > 0) {
                                    errors.forEach(errMessage => {
                                        showDangerToast(errMessage, "Error", "Unable to delete Device Type");
                                    })
                                } else {
                                    showSuccessToast("Device Types were removed", "Remove Device Type")
                                }
                            }),
                        undefined,
                        'Remove Device Types',
                        'Warning: All assigned events will be removed.'
                    ))
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.REMOVE);
        setShowModal(true);

    }

}
